import { Component, OnInit, ViewChild, TemplateRef, Output, Input, OnChanges, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { BehaviorSubject ,  Observable } from 'rxjs';

import { Tag, TagsUsage } from '../tags/models';
import { TagsService } from './services/tags.service';
import { DxTagBoxModule } from 'devextreme-angular';
import { FormsModule } from '@angular/forms';

@Component({
    templateUrl: './tag-selector.component.html',
    selector: 'ep-tag-selector',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [DxTagBoxModule, FormsModule]
})
export class TagSelectorComponent implements OnInit, OnChanges {
    constructor(private tagsService: TagsService) {

        this.tagsService.getTags(TagsUsage.Partner).then(tags => {
            let tagObject = tags.sort((t1: Tag, t2: Tag) => t1.Name.localeCompare(t2.Name)).map((t) => ({ name: t.Name, value: t.Id }));
            this.availableTags = tagObject;
        });

    }
    
    public tagObject: any;
    public selectedTags: any[] = [];
    public availableTags: any[] = [];

    //@Input() readonly: boolean;
    @Input() public tags: string;
    @Output() public tagsChange: EventEmitter<string> = new EventEmitter<string>();
    @Output() public selectedTagsChange: EventEmitter<any> = new EventEmitter<any>();

    ngOnInit(): void {

    }

    ngOnChanges(changes: any) {
        if (!this.internalChange) {
            if (changes.tags && this.tags !== undefined && this.tags !== null) {
                this.selectedTags = [];
                let tagsArray = this.tags.split(',');
                if (tagsArray) {
                    tagsArray.forEach(w => {
                        if (w) {
                            let item = this.tagObject[w.trim()];
                            if (item) {
                                this.selectedTags.push(item);
                            }
                        }
                    });
                }
            }
            else if (changes.tags) {
                this.selectedTags = [];
            }
        }
        this.internalChange = false;
    }

    internalChange = false;
    onValueChanged(e: any) {
        this.internalChange = true;
        //this.tags = this.selectedTags.map(w => w.value).join(',');
        //this.tagsChange.emit(this.tags);
        this.selectedTagsChange.emit(this.selectedTags);
        this.internalChange = false;
    }
}